(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('multiple-commands', {
                parent: 'management',
                url: '/multiple-commands/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.actionCommands.multiple.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/multiple-commands/multiple-commands.html',
                        controller: 'MultipleCommandsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    }

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            search: $stateParams.search,
                            filter: $stateParams.listFilter,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('multiple-commands-arguments', {
                parent: 'management',
                url: '/multiple-commands-arguments',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.actionCommands.multiple.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/multiple-commands/multiple-commands-arguments.html',
                        controller: 'MultipleCommandsArgumentsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    objects: {
                        value: [],
                        squash: true
                    },
                    commands: {
                        value: [],
                        squash: true
                    },
                    macros: {
                        value: [],
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
